//      
import React, { Component,           } from 'react';
import styled from 'styled-components';

                                      

import { mergeClassNames } from 'utils/functions';

                                   

                    
                                             
                   
                                            
                     
                                                            
                     
                                             
                   
                                          
                      
                                                  
                   
  

// sync with the LinkButton
const StyledButton = styled.button`
    border: none;
    border-radius: ${props => props.theme.radiusSm};
    cursor: pointer;
    &.btn-link {
        padding: 0 0.75rem;
    }
`;

/** A component for a button. */
export class Button extends Component              {
    static defaultProps = {
        flavor: 'secondary',
        className: '',
        outline: false,
        block: false,
        size: '',
    };

    render() {
        let {
            flavor,
            size,
            className,
            outline,
            block,
            children,
            ...domProps
        } = this.props;
        className = mergeClassNames(
            'btn',
            outline ? `btn-outline-${flavor}` : `btn-${flavor}`,
            `${size ? 'btn-' + size : ''}`,
            block ? 'btn-block' : '',
            className
        );

        return (
            <StyledButton type='button' className={className} {...domProps}>
                {children}
            </StyledButton>
        );
    }
}

export default Button;
